module.exports = __webpack_public_path__ + "static/media/greenRev_mobile.c396c63d.png";